export default "__VITE_ASSET__f136a25f__"